var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRefer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REFER"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.83984 18.3337C2.83984 15.1087 6.04818 12.5003 9.99818 12.5003C10.7982 12.5003 11.5732 12.6087 12.2982 12.8087M9.99818 10.0003C11.1032 10.0003 12.1631 9.56134 12.9445 8.77994C13.7259 7.99853 14.1648 6.93873 14.1648 5.83366C14.1648 4.72859 13.7259 3.66878 12.9445 2.88738C12.1631 2.10598 11.1032 1.66699 9.99818 1.66699C8.89311 1.66699 7.8333 2.10598 7.0519 2.88738C6.2705 3.66878 5.83151 4.72859 5.83151 5.83366C5.83151 6.93873 6.2705 7.99853 7.0519 8.77994C7.8333 9.56134 8.89311 10.0003 9.99818 10.0003Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.243 14.9837H13.7596M15.0013 13.767V16.2587M18.3346 15.0003C18.3346 15.267 18.3013 15.5253 18.2346 15.7753C18.1596 16.1087 18.0263 16.4337 17.8513 16.717C17.5575 17.2107 17.1402 17.6195 16.6405 17.9029C16.1408 18.1864 15.5758 18.3349 15.0013 18.3337C14.1808 18.3361 13.3895 18.0297 12.7846 17.4753C12.5346 17.2587 12.318 17.0003 12.1513 16.717C11.8341 16.2007 11.6667 15.6063 11.668 15.0003C11.6674 14.5624 11.7533 14.1287 11.9206 13.7241C12.0879 13.3194 12.3334 12.9517 12.6431 12.6421C12.9527 12.3324 13.3204 12.0869 13.725 11.9196C14.1297 11.7523 14.5634 11.6664 15.0013 11.667C15.9846 11.667 16.8763 12.092 17.4763 12.7753C18.0096 13.367 18.3346 14.1503 18.3346 15.0003Z",
    stroke: "#7E7E80",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRefer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/refer.6bae501a.svg";
export { ForwardRef as ReactComponent };